// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"App_noScrolling__1zqug"};